import React from 'react'

const floatingBookACall = () => {
    return (
                    <a href="https://zcal.co/i/c9mEbhSA" target='_blank' style={styles.floatingLink}>
                        <button className='heavy' style={{ ...{ width: "auto" }, ...styles.floatingButton }}>
                            Book a call/meeting with us
                        </button>
                    </a>
    )
}

const styles = {
    floatingLink: {
        position: 'fixed',
        top: '3em',
        right: '12px',
        display: 'block',
        zIndex: 1000,
    },
    floatingButton: {
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        padding: '0.5em 1em',
        cursor: 'pointer',
        margin:'0 0 2em 0',
        // fontSize:'0.5rem !important',
        // font:'revert !important'
    }
}

export default floatingBookACall
